import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import axios from "axios";

import { urlSafe } from './helpers';

function getType(row) {
    if (row.MHL === 1)
        return "Mega";
    if (row.HL === 1)
        return "Top";
    return "Standard";
}

function url(lang, row) {
    const path = urlSafe(row.Beschreibung)
    const fullUrl = `https://frankgrosseworldlist.com/${lang}/worldlist/${path}`;
    return fullUrl;
}

const Download = () => {
    const [data, setData] = useState([]);

    const { lang } = useParams();
    const { i18n } = useTranslation();
    // Change the language dynamically
    React.useEffect(() => {
        i18n.changeLanguage(lang);

        var url = `${process.env.REACT_APP_DATA_HOST}/${lang}/events`
        // do not allow this in production
        if (process.env.NODE_ENV !== 'development')
            url = "";
        axios.get(url).then(res => {
            const data = res.data.data;
            // console.log(data);
            setData(data);
        })
    }, [lang, i18n]);

    return (
        <>
            <textarea
                readOnly
                style={{ width: '80vw', height: '80vh' }}
                value={
                    data.map((row, i) => `${row.Kontinent}|${row.Land}|${row.LandRegion}|${getType(row)}|${row.Beschreibung}|${url(lang, row)}`).join("\n")
                }
            />
        </>
    )
}

export default Download;